var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpCenter = function SvgHelpCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2498 7.08268C11.2498 7.77304 10.6902 8.33268 9.99984 8.33268C9.30948 8.33268 8.74984 7.77304 8.74984 7.08268C8.74984 6.39233 9.30948 5.83268 9.99984 5.83268C10.6902 5.83268 11.2498 6.39233 11.2498 7.08268Z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9165 14.166V12.4993H9.1665V10.8327H8.33317V9.16602H9.99984C10.4601 9.16602 10.8332 9.53911 10.8332 9.99935V12.4993H12.0832V14.166H7.9165Z",
    fill: "#A4A4A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 18.3327C5.39746 18.3327 1.6665 14.6017 1.6665 9.99935C1.6665 5.39698 5.39746 1.66602 9.99984 1.66602C14.6022 1.66602 18.3332 5.39698 18.3332 9.99935C18.3332 14.6017 14.6022 18.3327 9.99984 18.3327ZM9.99984 16.666C13.6817 16.666 16.6665 13.6812 16.6665 9.99935C16.6665 6.31745 13.6817 3.33268 9.99984 3.33268C6.31794 3.33268 3.33317 6.31745 3.33317 9.99935C3.33317 13.6812 6.31794 16.666 9.99984 16.666Z",
    fill: "#A4A4A4"
  })));
};
export { SvgHelpCenter as ReactComponent };
export default __webpack_public_path__ + "assets/12f4ce8a.svg";